import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import theme from 'products/nomad_insurance/style/theme';
import useWindowSize from 'hooks/useWindowSize';
import { SCREEN_SIZES } from 'style';
import DesktopNavigation from './desktop';
import MobileNavigation from './mobile';

const Navigation = ({ isVisible, transparent, isProductNavOpen, ...restProps }) => {
  const { width } = useWindowSize();

  return (
    <ThemeProvider theme={theme}>
      {width >= SCREEN_SIZES.desktop ? (
        <DesktopNavigation
          isVisible={isVisible}
          transparent={transparent}
          {...restProps}
        />
      ) : (
        <MobileNavigation isProductNavOpen={isProductNavOpen} {...restProps} />
      )}
    </ThemeProvider>
  );
};

Navigation.defaultProps = {
  isVisible: false,
  transparent: false
};

Navigation.propTypes = {
  isVisible: PropTypes.bool,
  transparent: PropTypes.bool,
  isProductNavOpen: PropTypes.func
};

export default Navigation;
